import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Sparkles, Check, Trash2 } from "lucide-react";

export const IntakePreviewDialog = ({ open, onOpenChange, result, onApply }) => {
  const [fields, setFields] = useState({});
  const [narrative, setNarrative] = useState("");
  useEffect(() => { if (result) { setFields({ ...(result.fields || {}) }); setNarrative(result.narrative || ""); } }, [result]);
  const labels = result?.labels || {};
  const keys = Object.keys(fields);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="intake-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-[#1E88E5]" /> Dati letti dal modulo</DialogTitle>
          <DialogDescription>Controlla e correggi i valori prima di inserirli nella visita ({keys.length} campi · lettura {result?.read_mode}).</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {keys.map((k) => (
            <div key={k} className="flex items-center gap-2" data-testid={`intake-preview-${k}`}>
              <span className="text-[11px] text-slate-500 w-44 flex-shrink-0 leading-tight">{labels[k] || k}</span>
              <Input value={fields[k]} onChange={(e) => setFields({ ...fields, [k]: e.target.value })} className="h-8 text-sm" />
              <button type="button" onClick={() => { const f = { ...fields }; delete f[k]; setFields(f); }} className="text-slate-400 hover:text-red-600" title="Scarta" data-testid={`intake-preview-drop-${k}`}>
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
          <div className="pt-2">
            <span className="text-[11px] text-slate-500">Sintesi anamnestica (AI) — modificabile</span>
            <Textarea rows={5} value={narrative} onChange={(e) => setNarrative(e.target.value)} data-testid="intake-preview-narrative" />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button onClick={() => { onApply(fields, narrative); onOpenChange(false); }} className="bg-[#1E88E5] hover:bg-[#1976D2] text-white" data-testid="intake-preview-apply">
            <Check className="h-4 w-4 mr-1.5" /> Applica alla visita
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
